import axios from "axios";
import { http } from "../../httpconfig";

const service = axios.create({
  timeout: 5000,
  baseURL: http,
  headers: { "Content-Type": "application/json" },
});

service.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    console.log(error);
    return Promise.reject();
  }
);

service.interceptors.response.use(
  async (response) => {
    if (response.status === 200) {
      const { data } = response;
      return data;
    } else {
      Promise.reject();
    }
  },
  (error) => {
    console.log(error);
    return Promise.reject();
  }
);

export default service;
